import MdaeCurrencyBox from "./component";

export interface IMdaeCurrencyBoxProps {
  id: string;
  // Title shown next to the field.
  title: string;
  // Current numeric value (a number, or a value coercible to one).
  value: any;
  // Raw numeric values offered in the suggestion dropdown.
  dataSourceValues: number[];
  // Called when the value is committed (on blur or dropdown selection) with the numeric value.
  onValueCommitted: (value: any) => void;
  readOnly?: boolean;
  required?: boolean;
  // Optional component rendered next to the title (e.g. a pull-value button).
  titleComponent?: React.FC<any> | null;
  // Accepted for parity; the underlying MdaeNumericBox applies the dollar-icon title style
  // automatically when a title component is present, so it is not consumed directly.
  titleComponentClassName?: string;
  onKeyDown?: (e: any) => void;
  children?: React.ReactNode;
}

export default MdaeCurrencyBox;
